/**
 * Localize an objection code returned by the objections API (#842).
 *
 * The server sends a code from the closed set (`OBJECTION_CODES`), never a
 * display name; `objectionCodes.*` i18n keys exist for exactly that set. A code
 * outside this client's set — a newer set shipped before the tab reloaded —
 * falls back to the live wording the server sends alongside it rather than to
 * a raw key, so a set revision degrades the card instead of blanking it.
 */
import { isObjectionCode } from '@aica/core/voc';

/**
 * Any translate function: a hook's `t`, a fixed `t`, or a view model's own —
 * the exports name a code the way the card does (#2350).
 */
type ObjectionCodeTranslate = (key: string, options: { defaultValue: string }) => string;

export function localizeObjectionCode(
  code: string,
  fallback: string,
  t: ObjectionCodeTranslate
): string {
  // A code of the set whose atom a bundle lacks reads as the fallback too.
  return isObjectionCode(code)
    ? t(`objectionCodes.${code}`, { defaultValue: fallback })
    : fallback;
}
